"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.computeInterfaceId = void 0;

var _ethers = require("ethers");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const ethers = _objectSpread({}, _ethers.ethers);

if (ethers.version.startsWith("6.")) {
  ethers.utils = {
    id: ethers.id
  };
}

const utils = ethers.utils;

const computeInterfaceId = (functionSignatures = []) => {
  const INTERFACE_ID_LENGTH = 4;
  const interfaceIdBuffer = functionSignatures.map(signature => utils.id(signature)).map(h => Buffer.from(h.substring(2), "hex").slice(0, 4) // bytes4()
  ).reduce((memo, bytes) => {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < INTERFACE_ID_LENGTH; i++) {
      // eslint-disable-next-line no-param-reassign,operator-assignment,no-bitwise
      memo[i] = memo[i] ^ bytes[i]; // xor
    }

    return memo;
  }, Buffer.alloc(INTERFACE_ID_LENGTH));
  return `0x${interfaceIdBuffer.toString("hex")}`;
};

exports.computeInterfaceId = computeInterfaceId;